<div class="message-container" *ngIf="!message.Payload.IsPassword || message.Direction == 'BotToUser'" [innerHTML]="safeHtml">
</div>
<div *ngIf="message.Payload.IsPassword && message.Direction != 'BotToUser'">
    ****
</div>
